import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import React from "react";
import startSvg from "../../../assets/books/action_icons/Start.svg";
import doneSvg from "../../../assets/books/action_icons/done.svg";
import { useGetQuestCourseByIdQuery } from "../../../redux-toolkit/features/courses/coursesApiSlice";
import ProgressBar from "../../UI/ProgressBar";
import { CourseCover } from "./CourseCover";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SyncIcon from "@mui/icons-material/Sync";
import StarIcon from "@mui/icons-material/Star";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import {
  Button,
  Dialog,
  TextField,
  Tooltip,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { useAlert } from "../../../hooks/useAlert";
import { useSendTaskMutation } from "../../../redux-toolkit/features/books/bookApiSlice";
import { useSelector } from "react-redux";
import {
  validateTaskSubmissionImageFile,
} from "../../../utils/taskSubmissionImage";
import { RequiredAsterisk } from "../../UI/RequiredAsterisk/RequiredAsterisk";

const formatRejectedDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const latestRejectionEntries = (reasons) =>
  Array.isArray(reasons) ? [...reasons].reverse() : [];

const RejectionPreview = ({ reasons, onViewAll }) => {
  const entries = latestRejectionEntries(reasons);
  const latest = entries[0];
  if (!latest) return <span>NA</span>;

  const date = formatRejectedDate(latest.rejectedAt);
  const reason = latest.reason?.trim() || "NA";

  return (
    <div className="booksLevels__rejectionPreview">
      <div className="booksLevels__rejectionPreviewHead">
        <span className="booksLevels__rejectionPreviewLabel">Rejection reason</span>
        {date ? <span className="booksLevels__rejectionPreviewDate">{date}</span> : null}
      </div>
      <p>{reason}</p>
      {entries.length > 1 ? (
        <button
          type="button"
          onMouseDown={(event) => event.preventDefault()}
          onClick={onViewAll}
        >
          view all →
        </button>
      ) : null}
    </div>
  );
};

const RejectionHistoryDialog = ({ open, onClose, reasons, taskNumber }) => {
  const entries = latestRejectionEntries(reasons);
  const countLabel = `${entries.length} rejection${entries.length === 1 ? "" : "s"}`;

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ className: "booksLevels__historyDialog" }}>
      <div className="booksLevels__historyHeader">
        <div className="booksLevels__historyTitleBlock">
          <h2>Rejection history</h2>
          <p>
            Task {taskNumber} · {countLabel} · Latest first
          </p>
        </div>
        <button
          type="button"
          className="booksLevels__historyClose"
          onClick={onClose}
          aria-label="Close rejection history"
        >
          <CloseOutlined />
        </button>
      </div>
      <div className="booksLevels__historyDivider" />
      <div className="booksLevels__historyList">
        {entries.map((entry, index) => {
          const date = formatRejectedDate(entry?.rejectedAt);
          const reason = entry?.reason?.trim() || "NA";
          const isLatest = index === 0;
          const isLast = index === entries.length - 1;
          return (
            <div className="booksLevels__historyItem" key={`${entry?.rejectedAt || "na"}-${index}`}>
              <div className="booksLevels__historyTimeline">
                <span
                  className={
                    isLatest
                      ? "booksLevels__historyDot booksLevels__historyDot--latest"
                      : "booksLevels__historyDot"
                  }
                />
                {isLast ? null : <span className="booksLevels__historyLine" />}
              </div>
              <div
                className={
                  isLast
                    ? "booksLevels__historyContent booksLevels__historyContent--last"
                    : "booksLevels__historyContent"
                }
              >
                <div className="booksLevels__historyItemHead">
                  <strong>{date || "NA"}</strong>
                  {isLatest ? <span className="booksLevels__historyLatest">Latest</span> : null}
                </div>
                <p>{reason}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "50%",
  transform: "translate(-50%, -50%)",
  width: "50vw",
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: "25px 40px",
};

export const LevelTask = ({
  index,
  task,
  bookTheme,
  refetch,
  levelId,
  bookId,
  bookName,
  levelName,
}) => {
  const [open, setOpen] = React.useState(false);
  const [openTask, setOpenTask] = React.useState(false);
  const [thumbnail, setThumbnail] = React.useState();
  const [url, setUrl] = React.useState("");
  const [inUrlValid, setInUrlValid] = React.useState(false);
  const [notes, setNotes] = React.useState();
  const [sendTask] = useSendTaskMutation();
  const { displayAlert } = useAlert();
  const [isLarge, setIsLarge] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = async () => {
    setCourseId(null);
    await clearHandler();
    setOpen(false);
  };
  const bookMode = useSelector((state) => state.theme.bookMode);

  const handleOpenTask = () => {
    clearHandler();
    setOpenTask(true);
  };
  const handleOpenClose = () => {
    clearHandler();
    setOpenTask(false);
  };
  const [courseId, setCourseId] = React.useState(null);
  const [rejectionTipOpen, setRejectionTipOpen] = React.useState(false);
  const [rejectionHistoryOpen, setRejectionHistoryOpen] = React.useState(false);

  const { data, isSuccess } = useGetQuestCourseByIdQuery(courseId, {
    skip: courseId === null,
    refetchOnMountOrArgChange: true,
  });

  const thumbnailHandler = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validationError = validateTaskSubmissionImageFile(file);
    if (validationError) {
      setIsLarge(validationError.includes("1MB"));
      return displayAlert({
        open: true,
        message: validationError,
        type: "error",
        timeout: "2000",
      });
    }

    setIsLarge(false);
    setThumbnail(file);
  };

  function normalizeUrlInput(string = "") {
    return string.trim().replace(/^(https?:\/\/)+/i, "");
  }

  const urlHandler = (event) => {
    if (inUrlValid) setInUrlValid(false);
    const normalizedValue = normalizeUrlInput(event.target.value);
    setUrl(normalizedValue ? `https://${normalizedValue}` : "");
  };

  const clearHandler = () => {
    setInUrlValid(false);
    setUrl("");
    setThumbnail();
    setNotes("");
  };

  function normalizeUrl(string = "") {
    const normalizedValue = normalizeUrlInput(string);
    return normalizedValue ? `https://${normalizedValue}` : "";
  }

  function isValidUrl(string) {
    try {
      const parsedUrl = new URL(string);
      return (
        (parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:") &&
        parsedUrl.hostname.includes(".")
      );
    } catch (err) {
      return false;
    }
  }

  const sendHandler = () => {
    const taskData = new FormData();
    const normalizedUrl = normalizeUrl(url);
    if (url && !isValidUrl(normalizedUrl)) {
      setInUrlValid(true);
      return displayAlert({
        open: true,
        message: `Invalid URL format`,
        type: "error",
        timeout: "2000",
      });
    }

    if (thumbnail) {
      const validationError = validateTaskSubmissionImageFile(thumbnail);
      if (validationError) {
        setIsLarge(validationError.includes("1MB"));
        return displayAlert({
          open: true,
          message: validationError,
          type: "error",
          timeout: "2000",
        });
      }
    }

    taskData.append("file", thumbnail);
    taskData.append("url", normalizedUrl);
    taskData.append("comments", notes);
    if (!thumbnail && !url && !notes) {
      return displayAlert({
        open: true,
        message: `Add either an image, Note or a URL.`,
        type: "error",
        timeout: "2000",
      });
    } else {
      sendTask({ bookId, taskId: task._id, levelId, taskData })
        .unwrap()
        .then(() => {
          displayAlert({
            open: true,
            message:
              "Task Submitted Successfully! Points Will Be Allocated After Admin Approval.",
            type: "success",
            timeout: "4000",
          });
        })
        .catch((err) => {
          console.log("err?.error", err);

          const errorText =
            `${err?.error || ""} ${err?.message || ""}`.toLowerCase();
          const isNetworkError =
            err?.status === "FETCH_ERROR" ||
            err?.status === "TIMEOUT_ERROR" ||
            (err?.status === "PARSING_ERROR" && err?.originalStatus === 0) ||
            errorText.includes("failed to fetch") ||
            errorText.includes("networkerror") ||
            errorText.includes("load failed") ||
            navigator.onLine === false;

          displayAlert({
            open: true,
            message: isNetworkError
              ? "No internet connection. Please check your network and try again."
              : err?.data?.message || `Error while sending the task`,
            type: "error",
            timeout: "2000",
          });
        })
        .finally(() => {
          refetch();
          handleClose();
        });
    }
  };

  const courseOpenHandler = (_id) => {
    setCourseId(_id);
    handleOpen();
  };

  return (
    <div>
      {!openTask ? (
        <div key={index}>
          <div className="booksLevels__que">
            <h4>Task {index + 1}:</h4>
            <h4>{task.description}</h4>
          </div>
          <div className="booksLevels__ans">
            <div>
              {bookMode === "dark" ? (
                <StarIcon
                  sx={{
                    color:
                      task.status === "APPROVED"
                        ? "var(--sstar)"
                        : "var(--grey700)",
                    fontSize: "20px",
                  }}
                />
              ) : (
                <StarIcon
                  sx={{
                    color:
                      task.status === "APPROVED" ? "var(--sstar)" : "white",
                    fontSize: "20px",
                  }}
                />
              )}
              <h5> {task.points ?? 0}</h5>
            </div>
            <div>
              <>
                {task.isStarted === false &&
                  task.isFinished === false &&
                  task.course != null && (
                    <Button
                      startIcon={<img height={"15px"} src={startSvg} alt="" />}
                      onClick={() => courseOpenHandler(task.course?._id)}
                      variant="contained"
                    >
                      Start
                    </Button>
                  )}
                {task.isStarted === true &&
                  task.isFinished === false &&
                  task.course != null && (
                    <Button
                      startIcon={<img height={"15px"} src={startSvg} alt="" />}
                      onClick={() => courseOpenHandler(task.course?._id)}
                      variant="contained"
                    >
                      Continue
                    </Button>
                  )}
                {task.isFinished === true && task.course != null && (
                  <Button
                    startIcon={<img width={"15px"} src={doneSvg} alt="" />}
                    variant="contained"
                    color="success"
                    onClick={() => courseOpenHandler(task.course?._id)}
                  >
                    Done
                  </Button>
                )}

                {task.status === "INCOMPLETE" && task.course === null && (
                  <Button
                    startIcon={<img width={"15px"} src={startSvg} alt="" />}
                    onClick={handleOpenTask}
                    variant="contained"
                  >
                    Start
                  </Button>
                )}

                {task.status === "REJECTED" && task.course === null && (
                  <div className="booksLevels__rejectedActions">
                    <Tooltip
                      open={rejectionHistoryOpen ? false : rejectionTipOpen}
                      onOpen={() => setRejectionTipOpen(true)}
                      onClose={() => setRejectionTipOpen(false)}
                      title={
                        <RejectionPreview
                          reasons={task.rejectionReasons}
                          onViewAll={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setRejectionTipOpen(false);
                            setRejectionHistoryOpen(true);
                          }}
                        />
                      }
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#fff",
                            color: "inherit",
                            maxWidth: 280,
                            p: 0,
                            borderRadius: "10px",
                            border: "1px solid #f0f0f0",
                            boxShadow: "0 8px 24px rgba(16, 24, 40, 0.12)",
                          },
                        },
                      }}
                    >
                      <span className="booksLevels__status booksLevels__status--rejected">
                        <ErrorOutlineIcon />
                        Rejected
                      </span>
                    </Tooltip>
                    <RejectionHistoryDialog
                      open={rejectionHistoryOpen}
                      onClose={() => setRejectionHistoryOpen(false)}
                      reasons={task.rejectionReasons}
                      taskNumber={index + 1}
                    />
                    <Button
                      className="booksLevels__resubmit"
                      onClick={handleOpenTask}
                      variant="contained"
                      startIcon={<SyncIcon />}
                    >
                      Resubmit
                    </Button>
                  </div>
                )}
                {task.status === "APPROVED" && task.course === null && (
                  <span className="booksLevels__status booksLevels__status--approved">
                    <CheckCircleOutlineIcon />
                    Approved
                  </span>
                )}
                {task.status === "PENDING" && (
                  <span className="booksLevels__status booksLevels__status--pending">
                    <AccessTimeIcon />
                    Pending Approval
                  </span>
                )}
              </>
              <div>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    {data && (
                      <div className="create__formhead">
                        <h1></h1>
                        <CloseIcon
                          onClick={handleClose}
                          sx={{
                            fontSize: "18px",
                            cursor: "pointer",
                            marginBottom: "5px",
                            color: "var(--grey400)",
                            "&:hover": {
                              color: "var(--error)",
                            },
                          }}
                        />
                      </div>
                    )}

                    {!isSuccess ? (
                      <ProgressBar />
                    ) : (
                      <CourseCover
                        bookName={bookName}
                        levelName={levelName}
                        bookId={bookId}
                        levelId={levelId}
                        course={data?.data}
                        taskId={task?._id}
                        isCourseEnrolled={
                          task?.course?.coursecompletion ? true : false
                        }
                        points={task?.points}
                      />
                    )}
                  </Box>
                </Modal>
              </div>
            </div>
          </div>
          <img
            src={bookTheme?.subDivider}
            className="booksLevels_sepratorarrow levelresponsive__img"
            alt="sepratorArrow"
          />
        </div>
      ) : (
        <div key={index}>
          <div
            className="booktask"
            style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
          >
            <div className="booktask__close">
              <CloseIcon
                onClick={handleOpenClose}
                sx={{
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "var(--grey600)",
                  "&:hover": {
                    color: "var(--error)",
                  },
                }}
              />
            </div>
            <div className="booktask__content">
              <div className="booktask__head">
                <h5 className="ftwt__m">Points:</h5>
                <div>
                  <h5 className="ftwt__m">{task.points}</h5>
                </div>
              </div>
              <h5 className="ftwt__r" style={{ color: "#747474" }}>
                {task.description}
              </h5>
              <div
                style={{
                  borderColor: isLarge ? "var(--error)" : "",
                  backgroundColor:
                    (url && "var(--grey100)") || (notes && "var(--grey100)"),
                }}
                className="dropzone-wrapper"
              >
                {thumbnail ? (
                  <div className="dropzone-image">
                    <img
                      height={"100%"}
                      src={URL.createObjectURL(thumbnail)}
                      alt="Thumbnail Preview"
                    />
                    <CloseIcon
                      onClick={() => setThumbnail()}
                      sx={{
                        fontSize: "18px",
                        cursor: "pointer",
                        color: "var(--grey400)",
                        "&:hover": {
                          color: "var(--error)",
                        },
                      }}
                    />
                  </div>
                ) : (
                  <div className="dropzone-desc">
                    <UploadFileOutlinedIcon sx={{ fontSize: "70px" }} />
                    <p
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      Choose an image file{" "}
                      <span style={{ fontSize: "11px" }}>or drag it here.</span>
                      <span style={{ fontSize: "11px" }}>
                        Maximum file size 1MB
                      </span>
                    </p>
                  </div>
                )}
                {!thumbnail && (
                  <input
                    name="thumbnail"
                    onChange={thumbnailHandler}
                    type="file"
                    accept="image/*"
                    className="dropzone"
                  />
                )}
              </div>
              {isLarge && (
                <p
                  style={{
                    color: "var(--error)",
                    fontSize: "12px",
                  }}
                >
                  Choose Image smaller than 1MB
                </p>
              )}
              <div>
                <h6 className="ftwt__r">Upload from a URL</h6>
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": {
                      top: 0,
                    },
                    marginTop: "5px",
                  }}
                  variant="outlined"
                  placeholder="www.example.com"
                  fullWidth
                  value={normalizeUrlInput(url)}
                  error={inUrlValid ? true : false}
                  helperText={inUrlValid && "Detected Invalid Url."}
                  onChange={urlHandler}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">https://</InputAdornment>
                    ),
                  }}
                />
              </div>

              <div>
                <h6 className="ftwt__r">Additional notes to the submission.</h6>
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    marginTop: "5px",
                  }}
                  variant="outlined"
                  placeholder="Note"
                  fullWidth
                  multiline
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  rows={2}
                />
              </div>
              <div className="booktask__actions">
                <Button
                  variant="outlined"
                  color="error"
                  onClick={clearHandler}
                  sx={{
                    color: "var(--grey400)",
                    borderColor: "var(--grey400)",
                    width: "100px",
                    "&:hover": {
                      color: "var(--error)",
                    },
                  }}
                >
                  Reset
                </Button>
                <Button
                  variant="contained"
                  onClick={sendHandler}
                  sx={{
                    width: "100px",
                  }}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
          <img
            src={bookTheme?.subDivider}
            className="booksLevels_sepratorarrow levelresponsive__img"
            alt="sepratorArrow"
          />
        </div>
      )}
    </div>
  );
};
